import React from 'react';

/**
 * Componente Toggle Switch reutilizable
 * Usado para cambiar entre estados activo/inactivo con una interfaz visual atractiva
 */
const ToggleSwitch = ({ 
  label, 
  checked, 
  onChange, 
  activeText = "Activo", 
  inactiveText = "Inactivo",
  activeColor = "#28a745",
  inactiveColor = "#ccc"
}) => {
  return (
    <div style={{ marginTop: '0px' }}>
      <label className="modal-label" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        fontSize: '14px', 
        color: '#0063a1', 
        marginBottom: '8px' 
      }}>
        <span>
          {label}: {checked ? activeText : inactiveText}
        </span>
        <div style={{
          position: 'relative',
          width: '50px',
          height: '28px',
          backgroundColor: checked ? activeColor : inactiveColor,
          borderRadius: '14px',
          cursor: 'pointer',
          transition: 'background-color 0.3s'
        }}
        onClick={onChange}>
          <div style={{
            position: 'absolute',
            top: '2px',
            left: checked ? '24px' : '2px',
            width: '24px',
            height: '24px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transition: 'left 0.3s'
          }} />
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;